interface ContactInfoSectionProps {
  phone: string;
  address: string;
  onChangePhone: (value: string) => void;
  error?: string;
}

export default function ContactInfoSection({
  phone,
  address,
  onChangePhone,
  error,
}: ContactInfoSectionProps) {
  return (
    <section className="bg-background-50 rounded-card border border-background-200 overflow-hidden">
      <div className="flex items-center gap-3 px-5 py-4 border-b border-background-200">
        <div className="w-9 h-9 rounded-btn bg-secondary-100 flex items-center justify-center text-secondary-600">
          <i className="ri-contacts-book-2-line text-xl"></i>
        </div>
        <div>
          <h2 className="text-base font-bold text-foreground-900">بيانات التواصل</h2>
          <p className="text-xs text-foreground-500 mt-0.5">
            رقم الفرع الظاهر للعملاء وعنوانه
          </p>
        </div>
      </div>

      <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block mb-2 text-sm font-semibold text-foreground-700">
            رقم تواصل الفرع
          </label>
          <input
            type="tel"
            inputMode="numeric"
            dir="ltr"
            value={phone}
            onChange={(e) => onChangePhone(e.target.value)}
            placeholder="0112345678"
            className={`w-full h-11 rounded-btn border bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 px-4 outline-none text-right transition-all ${
              error
                ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-100"
                : "border-background-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-100"
            }`}
          />
          {error ? (
            <p className="mt-1.5 text-xs text-red-600 flex items-center gap-1">
              <i className="ri-error-warning-line text-sm"></i>
              {error}
            </p>
          ) : (
            <p className="mt-1.5 text-xs text-foreground-400">
              يُستخدم للتواصل مع الفرع في حالات الطوارئ
            </p>
          )}
        </div>

        <div>
          <label className="block mb-2 text-sm font-semibold text-foreground-700">
            عنوان الفرع
            <span className="mr-2 text-xs font-normal text-foreground-400">
              (للعرض فقط)
            </span>
          </label>
          <div className="w-full min-h-[2.75rem] flex items-center gap-2 rounded-btn border border-background-200 bg-background-100 px-4 py-3">
            <i className="ri-map-pin-2-line text-base text-foreground-400 shrink-0"></i>
            <span className="text-sm text-foreground-600 leading-relaxed">{address}</span>
          </div>
          <p className="mt-1.5 text-xs text-foreground-400">
            يُعدّل العنوان من لوحة صاحب المحل
          </p>
        </div>
      </div>
    </section>
  );
}